import { inject, InjectionToken } from '@angular/core';
import { KeyboardInfo } from '@capacitor/keyboard';
import { PluginListenerHandle } from '@capacitor/core';
import { Observable } from 'rxjs';
import { KeyboardService } from '../services';

export const KEYBOARD_TOKEN: InjectionToken<KeyboardProvider> = new InjectionToken<KeyboardProvider>('KEYBOARD_TOKEN', {
  factory: (): KeyboardProvider => {
    const keyboardService: KeyboardService = inject(KeyboardService);

    return {
      hide$(): Observable<void> {
        return keyboardService.hide();
      },

      show$(): Observable<void> {
        return keyboardService.show();
      },

      addListenerWillShow(callback: (info: KeyboardInfo) => void): Promise<PluginListenerHandle> {
        return keyboardService.addListenerWillShow(callback);
      },

      addListenerWillHide(callback: () => void): Promise<PluginListenerHandle> {
        return keyboardService.addListenerWillHide(callback);
      },

      addListenerDidShow(callback: (info: KeyboardInfo) => void): Promise<PluginListenerHandle> {
        return keyboardService.addListenerDidShow(callback);
      },

      addListenerDidHide(callback: () => void): Promise<PluginListenerHandle> {
        return keyboardService.addListenerDidHide(callback);
      }
    };
  }
});

export interface KeyboardProvider {
  hide$(): Observable<void>;
  show$(): Observable<void>;
  addListenerWillShow(callback: (info: KeyboardInfo) => void): Promise<PluginListenerHandle>;
  addListenerWillHide(callback: () => void): Promise<PluginListenerHandle>;
  addListenerDidShow(callback: (info: KeyboardInfo) => void): Promise<PluginListenerHandle>;
  addListenerDidHide(callback: () => void): Promise<PluginListenerHandle>;
}
